import React from "react";
import { Toaster } from "react-hot-toast";

const ToastNotification = () => {
  return (
    <Toaster
      position="top-right"
      reverseOrder={true}
      gutter={8}
      containerClassName=""
      containerStyle={{ marginTop: "10px" }}
      toastOptions={{
        className: "",
        duration: 2000,
        style: {
          background: "#393939",
          color: "#fff",
        },
      }}
    />
  );
};

export default ToastNotification;
